export default __webpack_public_path__ + "static/media/1.bc582a76.jpg";